function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 16.4103,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.4921 17.549L20.4849 13.6561C19.3911 13.0485 18.0469 13.8394 18.0469 15.0907V22.7817L27.4921 17.549ZM18.0469 26.6089L30.9413 19.4653L31.972 20.0379C32.493 20.3273 32.8161 20.8765 32.8161 21.4724V22.0786L18.0469 30.2609V26.6089ZM18.0469 34.088V37.7401L32.8161 29.5578V25.9057L18.0469 34.088ZM32.8161 33.3849L18.0469 41.5672V45.2192L32.8161 37.037V33.3849ZM32.8161 40.8641L18.0469 49.0464V50.5384C18.0469 51.7897 19.3911 52.5806 20.4849 51.9729L31.972 45.5912C32.493 45.3017 32.8161 44.7526 32.8161 44.1566V40.8641Z",
  fill: "url(#paint0_linear_5828:11347)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.0989 14.145C36.0989 12.9251 37.3827 12.1316 38.4738 12.6772L49.961 18.4208C50.5169 18.6988 50.8681 19.267 50.8681 19.8886V29.4412C50.8681 30.0129 50.5706 30.5434 50.0828 30.8415L38.5956 37.8614C37.5021 38.5296 36.0989 37.7427 36.0989 36.4611V14.145Z",
  fill: "#6236FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.8958 17.5594V33.3148C27.8958 34.5661 29.2399 35.357 30.3337 34.7494L41.3989 28.6021C42.1803 28.1679 42.665 27.3442 42.665 26.4503V24.424C42.665 23.53 42.1803 22.7063 41.3989 22.2722L30.3337 16.1249C29.2399 15.5172 27.8958 16.3081 27.8958 17.5594Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5828:11347",
  x1: 11.7055,
  y1: 13.4473,
  x2: 11.7055,
  y2: 46.7099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBF3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E47577"
})));

var SvgHitpawVideoEditorLogo = function SvgHitpawVideoEditorLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHitpawVideoEditorLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hitpaw-video-editor-logo.12848a09.svg";
export { ForwardRef as ReactComponent };